export function getRecommendedLink(
  leaderId: string,
  leaderName: string,
  set?: string,
  includeBase: boolean = false,
  gameName: string = "one-piece",
): string {
  let baseUrl = "";
  if (includeBase) {
    baseUrl = process.env.NEXT_PUBLIC_BASE_URL || "";
  }
  const setPath = set ? `/${set.toUpperCase()}` : "";
  return `${baseUrl}/${gameName}/decklist/${leaderId.toUpperCase()}/${formatLeaderNameUrl(leaderName)}${setPath}`;
}

export function formatLeaderNameUrl(leaderName: string): string {
  return leaderName.replaceAll(" ", "-").replaceAll(".", "-").toLowerCase();
}

export function getLeaderDecklistsLink(
  leaderId: string,
  leaderName: string,
  set?: string,
  gameName: string = "one-piece",
) {
  const setPath = set ? `/${set}` : "";
  return `/${gameName}/decklists/leader/${leaderId}/${formatLeaderNameUrl(leaderName)}${setPath}`;
}

export function getDeckRatiosLink(
  leaderId: string,
  leaderName: string,
  set?: string,
  gameName: string = "one-piece",
) {
  const setPath = set ? `/${set}` : "";
  return `/${gameName}/deck-ratios/leader/${leaderId}/${formatLeaderNameUrl(leaderName)}${setPath}`;
}
